import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';
import { Image } from '@garnish/media';

// ─────────────────────────────────────────────────────────────────────────────

export const AddToBagUnavailableIngredient = (props: Props) => {
  const { name, imageUrl } = props;

  return (
    <View style={styles.container}>
      <Image source={imageUrl} style={styles.image} />
      <BodyText sizeMatch={['18']}>{name}</BodyText>
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const IMAGE_SIZE = 30;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['2'],
  },
  image: {
    width: IMAGE_SIZE,
    height: IMAGE_SIZE,
    borderRadius: IMAGE_SIZE,
    backgroundColor: theme.colors.LIGHT,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  name: string;
  imageUrl: string;
};
